module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/hooks-lore-hook-dialog.json
// module id = 2204
// module chunks = 264113372471625